import 'react-notifications/lib/notifications.css'
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import { NotificationContainer, NotificationManager } from 'react-notifications'
import { FaPlus, FaCopy } from "react-icons/fa"
import AdminLayout from "../../../components/AdminLayout"

//Components
import AdminService from "../../../services/admin_services"

class AdminTrackers extends Component {
    constructor(props) {
        super(props)
        this.state = {
            trackers: [],
            deactivated: false,
            selectKey: null,
            order: 'asc',
            selected: [],
            processing: false,
        }
    }

    componentDidMount = async () => {
        await this.loadTrackers()
    }

    loadTrackers = async () => {
        const trackers = await AdminService.getTrackers()
        trackers.sort((a, b) => new Date(b.created_date || 0) - new Date(a.created_date || 0))
        this.setState({ trackers })
    }

    reorder = async (key) => {
        let order = 'asc'
        if (this.state.selectKey === key && this.state.order === 'asc')
            order = 'desc'
        this.setState({ selectKey: key, order })
        let trackers = this.state.trackers
        
        // Check if sorting by date field
        const dateFields = ['created_date', 'updated_date']
        if (dateFields.includes(key)) {
            if (order === 'asc')
                trackers.sort((a, b) => new Date(a[key] || 0) - new Date(b[key] || 0))
            else
                trackers.sort((a, b) => new Date(b[key] || 0) - new Date(a[key] || 0))
        } else {
            if (order === 'asc')
                trackers.sort((a, b) => (a[key] > b[key]) ? 1 : ((b[key] > a[key]) ? -1 : 0))
            else
                trackers.sort((a, b) => (a[key] < b[key]) ? 1 : ((b[key] < a[key]) ? -1 : 0))
        }
        this.setState({ trackers })
    }

    createNewTracker = async () => {
        if (window.confirm("Do you confirm tracker creation?")) {
            this.setState({processing: true})
            await AdminService.createTracker(this.state.title)
            NotificationManager.success('Tracker created')
            await this.loadTrackers()
            this.setState({processing: false})
        }
    }

    render() {
        return (
            <>
                <AdminLayout 
                    title="Trackers Management"
                    breadcrumbs={[{ label: 'Trackers' }]}
                >
                    <div className="space-y-6">
                        {/* Create New Tracker Form */}
                        <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-6 border border-amber-200">
                            <h3 className="text-lg font-semibold text-gray-900 mb-4 flex items-center gap-2">
                                <FaPlus className="text-amber-600" />
                                Create New Tracker
                            </h3>
                            
                            {this.state.processing ? (
                                <div className="text-center py-4">
                                    <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600"></div>
                                    <p className="text-gray-600 mt-2">Processing... please wait</p>
                                </div>
                            ) : (
                                <div className="flex gap-4">
                                    <input 
                                        type="text" 
                                        placeholder="Tracker title" 
                                        value={this.state.title} 
                                        onChange={(e) => this.setState({ title: e.target.value })}
                                        className="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-transparent outline-none"
                                    />
                                    <button 
                                        onClick={this.createNewTracker}
                                        className="px-6 py-2 bg-gradient-to-r from-amber-500 to-orange-600 text-white rounded-lg hover:from-amber-600 hover:to-orange-700 transition-all font-medium shadow-md hover:shadow-lg flex items-center gap-2"
                                    >
                                        <FaPlus />
                                        Create Tracker
                                    </button>
                                </div>
                            )}
                        </div>

                        {/* Trackers Table */}
                        <div className="overflow-x-auto bg-white rounded-xl border border-gray-200">
                            <table className="w-full">
                                <thead className="bg-gray-50 border-b border-gray-200">
                                    <tr>
                                        <th className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase">#</th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("title")}
                                        >
                                            Title ⥃
                                        </th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("created_date")}
                                        >
                                            Created ⥃
                                        </th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("token")}
                                        >
                                            Link ⥃
                                        </th>
                                        <th 
                                            className="px-4 py-3 text-left text-xs font-semibold text-gray-600 uppercase cursor-pointer hover:bg-gray-100"
                                            onClick={() => this.reorder("counter")}
                                        >
                                            Counter ⥃
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className="divide-y divide-gray-200">
                                    {this.state.trackers.map((tracker, index) => (
                                        <tr key={`tracker_${tracker.marketing_tracker_uuid}`} className="hover:bg-gray-50 transition-colors">
                                            <td className="px-4 py-4 text-sm font-medium text-gray-900">{index + 1}</td>
                                            <td className="px-4 py-4 text-sm font-medium text-gray-900">{tracker.title}</td>
                                            <td className="px-4 py-4 text-sm text-gray-600">
                                                {new Date(tracker.created_date).toLocaleDateString()}
                                            </td>
                                            <td className="px-4 py-4">
                                                <div className="flex items-center gap-2">
                                                    <code className="px-2 py-1 bg-gray-100 rounded text-xs font-mono text-gray-800 truncate max-w-xs">
                                                        {`https://play.loyalbuds.app?token=${tracker.token}`}
                                                    </code>
                                                    <button
                                                        onClick={() => {
                                                            navigator.clipboard.writeText(`https://play.loyalbuds.app?token=${tracker.token}`)
                                                            NotificationManager.success('Link copied to clipboard')
                                                        }}
                                                        className="p-1.5 bg-blue-100 text-blue-700 rounded-lg hover:bg-blue-200 transition-colors flex-shrink-0"
                                                        title="Copy link"
                                                    >
                                                        <FaCopy />
                                                    </button>
                                                </div>
                                            </td>
                                            <td className="px-4 py-4 text-sm font-semibold text-gray-900">{tracker.counter}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </AdminLayout>
                <NotificationContainer />
            </>
        )
    }
}

export default withTranslation()(AdminTrackers)